<template>
  <common-table :table-columns="tableColumns"
                :url="url" :operate="operate"
                :form-fields="formFields"
                :permission="permission"
                :searchs="searchs"
                ref="table"></common-table>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "@/utils/message";
import request from "@/utils/axios";

export default {
  name: 'ExportProductInformation',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'productName',
        placeholder: '商品名称',
        type: 'input'
      }],
      permission: {
        // add: 'exportProductInformation:add',
        update: 'exportProductInformation:update',
        delete: 'exportProductInformation:delete',
        deleteBatch: 'exportProductInformation:deleteBatch'
      },
      url: {
        get: '/exportProductInformation/listByCondition',
        add: '/exportProductInformation/add',
        // update: '/exportProductInformation/update',
        delete: '/exportProductInformation/delete',
        delete_batch: '/exportProductInformation/deleteBatch',
        status: '/exportProductInformation/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'douYinProductId',  // 字段名
          label: 'douYinProductId',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
        }, {
          field: 'productName',  // 字段名
          label: '商品名称',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'download',  // 字段名
          label: '下载链接',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
          detail: true
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '未剪辑',
              type: 'warning'
            }, {
              key: 1,
              value: '剪辑中',
              type: 'warning'
            }, {
              key: 2,
              value: '剪辑完成',
              type: 'success'
            }]
          },
        }, {
          field: 'downloadStatus',  // 字段名
          label: '压缩状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'tag',
            tags: [{
              key: 0,
              value: '失败',
              type: 'danger'
            }, {
              key: 1,
              value: '成功',
              type: 'success'
            }, {
              key: 2,
              value: '进行中',
              type: 'warning'
            }]
          },
        }, {
          field: 'content',  // 字段名
          label: '条件',  // 字段显示名称
          sort: false,  // 是否排序
          show: false,  // 是否展示
          detail: true
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'douYinProductId',  // 字段名
            label: 'douYinProductId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入douYinProductId',
            rules: [
              {required: true, message: 'douYinProductId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'download',  // 字段名
            label: 'download',  // 字段显示名称
            type: 'input',
            placeholder: '请输入download',
            rules: [
              {required: true, message: 'download不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'downloadStatus',  // 字段名
            label: 'downloadStatus',  // 字段显示名称
            type: 'input',
            placeholder: '请输入downloadStatus',
            rules: [
              {required: true, message: 'downloadStatus不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'content',  // 字段名
            label: 'content',  // 字段显示名称
            type: 'input',
            placeholder: '请输入content',
            rules: [
              {required: true, message: 'content不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [{
        icon: 'el-icon-edit',
        type: 'text',
        text: '剪辑',
        exist: (row) => {
          return row.status === 0 && this.$refs.table.havePermission('exportProductInformation:update')
        },
        handle: (row) => {
          if (row.status != 0) {
            message.warning("已剪辑，不可重复操作");
            return;
          }
          request.post({
            url: '/exportProductInformation/update',
            data: {id: row.id, status: 1},
            success: (data) => {
              if (data.code == 0) {
                message.success("操作成功");
                this.$refs.table.getData();
              } else {
                message.error("操作失败");
              }
            }
          });
        }
      }]
    }
  }
}
</script>

<style scoped>

</style>
